<template>
  <vf-button
    v-if="!isComingSoon && $feature.showFindInStoreOnPDP"
    class="p-0"
    size="tiny"
    variant="text-link"
    @click="handleFindInStore()"
  >
    <span class="text-xs underlined center i-flex">
      {{ $t.findInStore }}
    </span>
  </vf-button>
  <panel-variant-selection :size="{ sm: 'lg' }" />
</template>

<script lang="ts" setup>
import type { Props as VariantSelectionProps } from '#brand/components/dialog/variant-selection/VariantSelection.vue'

const { $feature } = useNuxtApp()
const {
  attributeSelectionLabels,
  findInStore,
  isComingSoon,
  nextAttribute
} = usePdp()

const PanelVariantSelection = createPanel('variant-selection')

const handleNextAttribute = (options: Omit<VariantSelectionProps, 'attribute'> = {}) => {
  if (!nextAttribute.value) return

  PanelVariantSelection.open({ attribute: nextAttribute.value, ...options })
  throw new Error('Select Next Attribute')
}

const handleFindInStore = () => {
  try {
    handleNextAttribute({ enableFindInStore: true })
    findInStore(attributeSelectionLabels.value)
  }
  catch (e) {
    console.info(e)
  }
}
</script>
